import React from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

const GuestModeFooter = () => {

    const  { t } = useTranslation();
    return (
        <>
            <div className='footerGuest p-1'>
                <a className='f-14'>{t("SignIn.Stay connected for Jobs & More")} <NavLink to="/SignUp" className='fw-bold'>
                {t("SignIn.Create an account")}</NavLink> {t("SignIn.or")} <span> <NavLink to="/SignIn">
                        <button type="button" className="mainBtn p-2" >
                           {t("SignIn.Sign in")}
                        </button>
                    </NavLink>

                </span></a>
            </div>
        </>
    )
}

export default GuestModeFooter